// Authorization
export const LOGIN = "login";
export const LOGOUT = "logout";
export const FETCH_USER = "fetchUser";

// Loader

export const CHANGE_LOADER = "changeLoader";
